import { render, staticRenderFns } from "./AppQuestion.vue?vue&type=template&id=2cc9e43c&scoped=true"
import script from "./AppQuestion.vue?vue&type=script&lang=ts"
export * from "./AppQuestion.vue?vue&type=script&lang=ts"
import style0 from "./AppQuestion.vue?vue&type=style&index=0&id=2cc9e43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc9e43c",
  null
  
)

export default component.exports